<template>
  <section :class="['container', getClass(currentIdx)]">
    <div class="columns">
      <Elevation :deskSize="8" :tabSize="10" :isReversed="currentIdx % 2 !== 0">
        <div class="column is-left">
          <LoremIpsum v-if="currentIdx % 2 === 0" />
          <ProForm v-if="currentIdx === 1" title="Professional" description="Let's talk about your work..." />
          <ContactForm v-if="currentIdx === 3" title="Contact" description="Finally, leave your contact details..." />
        </div>

        <div class="column is-right">
          <LoremIpsum v-if="currentIdx % 2 !== 0" />
          <IdentityForm v-if="currentIdx === 0" title="Identity" description="Who are you?" />
          <FantasyForm
            v-if="currentIdx === 2"
            title="Fantasy"
            description="In a parallel universe, who would you be?"
          />
        </div>
      </Elevation>
    </div>
  </section>
</template>

<script>
import { computed, inject } from 'vue';
import Elevation from '@/components/Elevation';
import LoremIpsum from '@/components/LoremIpsum';
import IdentityForm from './IdentityForm';
import ProForm from './ProForm';
import FantasyForm from './FantasyForm';
import ContactForm from './ContactForm';
import { CURRENT_IDX } from '@/StateProvider.vue';

export default {
  name: 'StateConsumer',
  components: {
    Elevation,
    LoremIpsum,
    IdentityForm,
    ProForm,
    FantasyForm,
    ContactForm
  },
  setup() {
    const currentIdx = inject(CURRENT_IDX);

    return { currentIdx: computed(() => currentIdx.value) };
  },
  methods: {
    getClass(idx) {
      switch (idx) {
        case 0:
          return 'is-blue';
        case 1:
          return 'is-red';
        case 2:
          return 'is-yellow';
        case 3:
          return 'is-green';
        default:
          return '';
      }
    }
  }
};
</script>
